import BookingRooms from "../../Components/Booking/BookingRooms.vue";
import BookingCapacity from "../../Components/Booking/BookingCapacity.vue";
import BookingOccurrences from "../../Components/Booking/BookingOccurrences.vue";
import BookingClientInfo from "../../Components/Booking/BookingClientInfo.vue";
import BookingEmail from "../../Components/Booking/BookingEmail.vue";
import BookingBillingUser from "../../Components/Booking/BookingBillingUser.vue";
import BookingSomethingNew from "../../Components/Booking/BookingSomethingNew.vue";
import BookingAssessmentType from "../../Components/Booking/BookingAssessmentType.vue";
import BookingConfirm from "../../Components/Booking/BookingConfirm.vue";
import BookingExperience from "../../Components/Booking/BookingExperience.vue";
import SoliForm from "./../../Components/Base/SoliForm";
import BookingRepeating from "../../Components/Booking/BookingRepeating.vue";
import BookingSelectClass from "../../Components/Booking/BookingSelectClass.vue";
import BookingEventType from "../../Components/Booking/BookingEventType.vue";
import BookingTemplateEvent from "../../Components/Booking/BookingTemplateEvent.vue";
import BookingPurchaseOption from "../../Components/Booking/BookingPurchaseOption.vue";
import BookingSelectCredit from "../../Components/Booking/BookingSelectCredit.vue";
import BookingPayment from "../../Components/Booking/BookingPayment.vue";
import BookingSubstitutePass from "../../Components/Booking/BookingSubstitutePass.vue";
import BookingSimpleSelect from "../../Components/Booking/BookingSimpleSelect.vue";
import BookingOffSiteLocation from "../../Components/Booking/BookingOffSiteLocation.vue";
import globalMoment from "../GlobalMoment";

export default {
    mixins: [globalMoment],
    components: {
        BookingExperience,
        BookingConfirm,
        BookingRooms,
        SoliForm,
        BookingSomethingNew,
        BookingAssessmentType,
        BookingBillingUser,
        BookingRepeating,
        BookingSelectClass,
        BookingEventType,
        BookingTemplateEvent,
        BookingPurchaseOption,
        BookingSelectCredit,
        BookingSubstitutePass,
        BookingEmail,
        BookingClientInfo,
        BookingPayment,
        BookingCapacity,
        BookingOccurrences,
        BookingSimpleSelect,
        BookingOffSiteLocation,
    },
    data() {
        return {
            rules: SoliForm.formRules,
            bookingComponents: {
                somethingNew: () => {
                    return {
                        name: "somethingNew",
                        title: () => "What would you like to do?",
                        header: true,
                        hideProgress: true,
                        hideCancelBtn: true,
                        value: () => this.form.somethingNew,
                        comp: "BookingSomethingNew",
                        hide: false, //this.getHideSomethingNew(),
                        props: () => ({
                            ref: "somethingNew",
                        }),
                        on: {
                            input: (e) => {
                                let event = this.form.credit;
                                this.$_select_somethingNew(e, event);
                            },
                        },
                        selection: {
                            data: () => {
                                if (this.form.somethingNew == null) return null;
                                return this.form.somethingNew
                                    ? "Something New"
                                    : "The Usual";
                            },
                            hide: this.form.somethingNew == null,
                        },
                        clear: () => {
                            this.form.somethingNew = null;
                            //if (this.bookingSource.isSelfServe) return;
                            //this.$_data_reset(true);
                            //this.form.location = null;
                        },
                    };
                },
                substitutePass: () => {
                    return {
                        name: "substitutePass",
                        title: () => "What would you like to do?",
                        header: true, //this.bookingSource.isMySchedule,
                        hideProgress: true, //this.bookingSource.isMySchedule,
                        hideCancelBtn: true, //this.bookingSource.isMySchedule,
                        value: () => this.form.substitutePass,
                        comp: "BookingSubstitutePass",
                        hide: this.getHideSubstitutePass(),
                        props: () => ({
                            ref: "substitutePass",
                        }),
                        on: {
                            input: (e) => {
                                let event = this.form.credit;
                                this.$_select_substitutePass(e, event);
                            },
                        },
                        selection: {
                            data: () => {
                                if (this.form.substitutePass == null)
                                    return null;
                                return this.form.substitutePass
                                    ? "Substitute Lesson"
                                    : "Find Class";
                            },
                            hide: false,
                        },
                        clear: () => {
                            /*if (this.bookingSource.isMySchedule) {
                                this.$_data_reset(true);
                                this.$_source_handleMyScheduleBooking(this.event);
                            }*/
                            this.form.substitutePass = null;
                        },
                    };
                },
                type: () => {
                    return {
                        name: "type",
                        title: () => "What would you like to schedule?",
                        header: true,
                        hideProgress: true,
                        hideCancelBtn: true,
                        value: () => this.form.type,
                        comp: "SoliLessonTypes",
                        hide: false,
                        props: () => ({
                            ref: "type",
                        }),
                        on: {
                            input: (e) => {
                                this.$_select_type(e);
                            },
                        },
                        selection: {
                            data: () => this.form.type?.name,
                            hide: true,
                            base: false,
                        },
                        clear: () => {
                            this.form.type = null;
                        },
                    };
                },
                /*email: () => {
                    return {
                        name: "email",
                        title: "Welcome!",
                        continue: true,
                        header: true,
                        hideProgress: true,
                        hideCancelBtn: true,
                        value: () => this.form.type,
                        comp: "BookingEmail",
                        hide: this.$page.props.auth.user?.email,
                        props: () => ({
                            ref: "email",
                        }),
                        on: {
                            valid: (e) => {
                                this.emailValid = !e;
                            },
                            mounted: (e) => {
                                this.emailValid = false;
                            },
                        },
                        selection: {
                            data: () => this.form.email,
                            hide: true,
                            base: false,
                        },
                        revisit: false,
                        clear: () => {
                            this.form.email = null;
                        },
                    };
                },*/
                assessmentType: () => {
                    return {
                        name: "assessmentType",
                        title: () => "What type of assessment?",
                        header: false,
                        hideProgress: false,
                        hideCancelBtn: false,
                        value: () => this.form.assessmentType,
                        comp: "BookingAssessmentType",
                        hide: this.getHideAssessmentType(),
                        stepDependent: {
                            value: () => !!this.form.type?.assessment,
                        },
                        props: () => ({
                            ref: "assessmentType",
                        }),
                        on: {
                            input: (e) => {
                                this.$_select_assessmentType(e);
                            },
                        },
                        //onDemand: true,
                        selection: {
                            data: () => this.form.assessmentType?.display,
                            hide: this.getHideAssessmentType(),
                        },
                        clear: () => {
                            //this.form.duration = null;
                            //this.form.instrument = null;
                            this.form.assessmentType = null;
                        },
                    };
                },
                eventType: () => {
                    return {
                        name: "eventType",
                        title: () => "What type of event?",
                        header: false,
                        hideProgress: false,
                        hideCancelBtn: false,
                        value: () => this.form.eventType,
                        comp: "BookingEventType",
                        hide: false,
                        props: () => ({
                            ref: "eventType",
                            loading: this.apiLoading,
                        }),
                        on: {
                            input: (e) => {
                                this.$_select_eventType(e);
                            },
                        },
                        selection: {
                            data: () => this.form.eventType,
                            hide: false,
                        },
                        clear: () => {
                            this.form.eventType = null;
                        },
                    };
                },
                templateEvent: () => {
                    return {
                        name: "templateEvent",
                        title: () => "Which class?",
                        header: false,
                        hideProgress: false,
                        hideCancelBtn: false,
                        value: () => this.form.templateEvent,
                        comp: "BookingTemplateEvent",
                        hide: false,
                        props: () => ({
                            ref: "templateEvent",
                            apiGroupEvents: this.apiGroupEvents,
                        }),
                        on: {
                            input: (e) => {
                                this.$_select_templateEvent(e);
                            },
                        },
                        selection: {
                            data: () => this.form.templateEvent?.title,
                            hide: false,
                        },
                        clear: () => {
                            //this.form.repeating = null;
                            //this.form.duration = null;
                            //this.form.online = null;
                            this.form.templateEvent = null;
                        },
                        showLoading: true,
                    };
                },
                selectClass: () => {
                    return {
                        name: "selectClass",
                        title: () => "Select from upcoming events",
                        header: false,
                        hideProgress: false,
                        hideCancelBtn: false,
                        value: () => this.form.selectClass,
                        comp: "BookingSelectClass",
                        hide: false,
                        props: () => ({
                            ref: "selectClass",
                            eventId: this.form.credit?.group_event?.id,
                            studentId: this.form.student?.id,
                        }),
                        on: {
                            input: (e) => {
                                this.$_select_class(e);
                            },
                        },
                        onDemand: true,
                        selection: {
                            data: () => this.form.selectClass?.title,
                            hide: false,
                        },
                        clear: () => {
                            this.form.selectClass = null;
                        },
                    };
                },
                repeating: () => {
                    return {
                        name: "repeating",
                        title: () => "Does this repeat?",
                        header: false,
                        hideProgress: false,
                        hideCancelBtn: false,
                        value: () => this.form.repeating,
                        comp: "BookingRepeating",
                        hide: false,
                        props: () => ({
                            ref: "repeating",
                        }),
                        on: {
                            input: (e) => {
                                this.$_select_repeating(e);
                            },
                        },
                        selection: {
                            data: () =>
                                this.form.repeating == null
                                    ? ""
                                    : this.form.repeating
                                    ? `Repeats ${
                                          this.form.templateEvent?.rrule_freq ??
                                          "Weekly"
                                      }`
                                    : "Does Not Repeat",
                            hide: false,
                        },
                        clear: () => {
                            this.form.repeating = null;
                        },
                    };
                },
                credit: () => {
                    return {
                        name: "credit",
                        credit: true,
                        title: () => "Which missed lesson?",
                        header: false,
                        hideProgress: false,
                        hideCancelBtn: false,
                        value: () => this.form.credit,
                        comp: "BookingSelectCredit",
                        hide: false,
                        props: () => ({
                            ref: "credit",
                            reschedules: this.apiCancelledLessons?.lessons,
                            loading: this.apiLoading,
                        }),
                        on: {
                            input: (e) => {
                                this.$_select_credit(e);
                            },
                        },
                        stepDependent: {
                            value: () => this.form.student,
                        },
                        showLoading: true,
                        selection: {
                            data: () => (this.form.credit ? "Use Pass" : null),
                            hide: false,
                        },
                        clear: () => {
                            this.form.credit = null;
                        },
                    };
                },
                student: () => {
                    return {
                        name: "student",
                        title: () => "Who is learning?",
                        subText: this.getStudentSubText(),
                        value: () => this.form.student,
                        comp: "SoliStudents",
                        hide: false,
                        props: () => ({
                            ref: "student",
                            autocomplete: true,
                            autofocus: true,
                            onDemand: !this.bookingSource.isSelfServe,
                            label: "Search Students",
                            filter: this.form.teacher
                                ? [this.form.teacher.id]
                                : [],
                            buttons: !!this.bookingSource.isSelfServe,
                            relationships: this.relationships ?? null,
                            targetDuration: this.form.duration,
                            lessonType: this.form.type?.name,
                            loading: this.apiLoading,
                        }),
                        classes: ["ma-4"],
                        on: {
                            input: (e) => {
                                this.$_select_student(e);
                            },
                        },
                        selection: {
                            data: () => this.form.student?.name,
                            hide: false,
                        },
                        showLoading: true,
                        clear: () => {
                            this.form.student = null;
                            this.form.courtesyReschedule = false;
                        },
                    };
                },
                billingUser: () => {
                    return {
                        name: "billingUser",
                        title: () => "Who is paying?",
                        value: () => this.form.billingUser,
                        comp: "BookingBillingUser",
                        onDemand: true,
                        props: () => ({
                            ref: "billingUser",
                            relationships: this.getBillingUserOptions(),
                        }),
                        on: {
                            input: (e) => {
                                this.$_select_billingUser(e);
                            },
                        },
                        hide: false, //this.getHideBillingUser(),
                        selection: {
                            data: () =>
                                "Paid for by " +
                                this.form.billingUser?.first_name,
                            hide: this.getHideBillingUser(),
                        },
                        clear: () => {
                            this.form.billingUser = null;
                        },
                    };
                },
                purchaseOption: () => {
                    return {
                        name: "purchaseOption",
                        title: () => "Select a pass or membership",
                        value: () => this.form.purchaseOption,
                        comp: "BookingPurchaseOption",
                        onDemand: true,
                        props: () => {
                            return {
                                ref: "purchaseOption",
                                purchaseOptions:
                                    this.$_data_filterPurchaseOptions(
                                        { type: this.form.type },
                                        this.form.student
                                    ),
                            };
                        },
                        on: {
                            input: (e) => {
                                this.$_select_purchaseOption(e);
                            },
                        },
                        hide: false, //this.getHidePurchaseOption(),
                        selection: {
                            data: () => this.form.purchaseOption?.name,
                            hide: this.bookingSource.isGuestSession,
                        },
                        clear: () => {
                            this.form.purchaseOption = null;
                        },
                        showLoading: true,
                    };
                },
                /*registrationOnly: () => {
                    return {
                        name: "registrationOnly",
                        title: () => "What would you like to do?",
                        value: () => this.form.registrationOnly,
                        comp: "BookingSimpleSelect",
                        onDemand: false,
                        props: () => {
                            return {
                                options: [
                                    {
                                        title: "Schedule this event",
                                        icon: "event",
                                        value: false,
                                    },
                                    {
                                        title: "Open registration",
                                        icon: "assignment",
                                        value: true,
                                    },
                                ],
                            };
                        },
                        on: {
                            input: (e) => {
                                this.$_select_registrationOnly(e);
                            },
                        },
                        hide: false,
                        selection: {
                            data: () =>
                                this.form.registrationOnly == null
                                    ? ""
                                    : this.form.registrationOnly
                                    ? "Registration Event"
                                    : "Schedule Event",
                            hide: false,
                        },
                        clear: () => {
                            this.form.registrationOnly = null;
                        },
                        showLoading: false,
                    };
                },*/
                online: () => {
                    return {
                        name: "online",
                        title: () => "Where?",
                        value: () => this.form.online,
                        comp: "SoliOnline",
                        hide: this.getHideOnline(),
                        props: () => ({
                            ref: "online",
                            onlineOnly: this.availability?.online_only,
                            teacher: this.form.teacher,
                            location: this.form.location,
                        }),
                        on: {
                            input: (e) => {
                                this.$_select_online(e);
                                this.$_apis_updateGuestSession();
                            },
                        },
                        selection: {
                            data: () =>
                                this.form.online == null
                                    ? ""
                                    : this.form.online
                                    ? "Online"
                                    : "In-Studio",
                            //base: this.getHideOnline(),
                            hide: false,
                            base: !this.form.somethingNew,
                        },
                        clear: () => {
                            this.form.online = null;
                        },
                    };
                },
                offSiteLocation: () => {
                    return {
                        name: "offSiteLocation",
                        title: () => "Where?",
                        value: () => this.form.offSiteLocation,
                        comp: "BookingOffSiteLocation",
                        hide: false,
                        props: () => ({
                            ref: "offSiteLocation",
                        }),
                        on: {
                            input: (e) => {
                                this.$_select_offSiteLocation(e);
                            },
                            valid: (e) => {
                                this.offSiteLocationValid = !e;
                            },
                            mounted: (e) => {
                                this.offSiteLocationValid = false;
                            },
                        },
                        continue: true,
                        //revisit: true,
                        selection: {
                            data: () => this.form.offSiteLocation?.name,
                            hide: false,
                        },
                        clear: () => {
                            this.offSiteLocationValid = true;
                            this.form.offSiteLocation = null;
                        },
                    };
                },
                location: () => {
                    return {
                        name: "location",
                        title: () => "Which location?",
                        value: () => this.form.location,
                        comp: "SoliLocations",
                        hide: false,
                        props: () => ({
                            ref: "location",
                            iterator: true,
                            showAddress: true,
                        }),
                        onDemand: true,
                        on: {
                            input: (e) => {
                                this.$_select_location(e);
                                this.$_apis_updateGuestSession();
                            },
                        },
                        selection: {
                            data: () => this.form.location?.name,
                            hide:
                                this.$page.props.staffView ||
                                this.$page.props.auth.user.virtual_client,
                            base: !this.form.somethingNew,
                        },
                        clear: () => {
                            this.form.location = null;
                        },
                    };
                },
                teacher: () => {
                    return {
                        name: "teacher",
                        title: () => "Which teacher?",
                        value: () => this.form.teacher,
                        comp: "SoliTeachers",
                        hide: false,
                        props: () => ({
                            ref: "teacher",
                            buttons: true,
                            instrument: this.form.instrument,
                            type: this.form.type?.reschedule
                                ? "Reschedule"
                                : this.form.type?.name,
                            filterTeacher: this.form.student?.id,
                            filterLocation: this.form.location
                                ? this.form.location.id
                                : this.$page.props.auth.user?.selected_location
                                      .id,
                            inStudio: !this.form.online,
                            all:
                                (this.form.type?.name == "Hold" &&
                                    this.bookingSource.isCalendar) ||
                                this.form.templateEvent?.registration_event,
                        }),
                        on: {
                            input: (e) => {
                                this.$_select_teacher(e);
                            },
                        },
                        onDemand: true,
                        selection: {
                            data: () => this.form.teacher?.name,
                            base:
                                this.event?.type?.recurring ||
                                !this.$page.props.staffView ||
                                this.$_data_authIsOnlyTeacher ||
                                this.event?.teacherView,
                            hide:
                                this.$_data_authIsOnlyTeacher &&
                                !this.form.type,
                        },
                        clear: () => {
                            this.form.teacher = null;
                            if (
                                this.getSortIndex("instrument") >
                                this.getSortIndex("teacher")
                            ) {
                                this.form.instrument = null;
                            }
                            this.assignment = null;
                            this.availability = null;
                            this.searchAssignments = [];
                            /*if (this.form.type?.assessment) {
                            this would allow selecting assessmentType in another teacher's assignment
                            not positive I want that to be possible.
                            if I want to do this, there are more conditions to write.
                            this.form.assessmentType = null;
                        }*/
                        },
                        showLoading: true,
                    };
                },
                duration: () => {
                    return {
                        name: "duration",
                        title: () => "How long?",
                        value: () => this.form.duration,
                        comp: "SoliDuration",
                        onDemand: true,
                        hide: false,
                        props: () => ({
                            ref: "duration",
                            event: this.event?.duration,
                            showAll: this.form.courtesyReschedule,
                            totalLessonCredits: this.getTotalLessonCredits(),
                            eventType: this.form.type,
                            purchaseOptions: this.$_data_getPurchaseOption,
                        }),
                        on: {
                            input: (e) => {
                                this.$_select_duration(e);
                            },
                        },
                        selection: {
                            data: () =>
                                this.form.duration
                                    ? this.form.duration > 60
                                        ? this.form.duration / 60 + " hrs"
                                        : this.form.duration + " min"
                                    : null,
                            hide: false,
                        },
                        clear: () => {
                            this.form.duration = null;
                        },
                    };
                },
                instrument: () => {
                    return {
                        name: "instrument",
                        title: () => "Which instrument?",
                        value: () => this.form.instrument,
                        comp: "SoliInstruments",
                        hide: false,
                        props: () => ({
                            buttons: true,
                            ref: "instrument",
                            inStudio: !this.form.online,
                            location: this.form.location,
                            bookingType: this.form.type.reschedule
                                ? "Reschedule"
                                : this.form.type.name,
                            user: this.form.student,
                            onlyAuth: this.$_data_authIsOnlyTeacher,
                            iterator: true,
                            autofocus: this.$vuetify.breakpoint.smAndUp,
                            parentInstruments:
                                this.availability?.instruments ??
                                this.form.teacher?.instruments,
                        }),
                        classes: ["pb-4"],
                        onDemand: this.bookingSource.isGuestSession,
                        on: {
                            input: (e) => {
                                this.$_select_instrument(e);
                                this.$_apis_updateGuestSession();
                            },
                        },
                        stepDependent: {
                            value: () => this.form.online !== null,
                        },
                        /*callback: () => {
                            this.$_apis_getTeacherAssignments();
                        },*/
                        selection: {
                            data: () => this.form.instrument?.name,
                            base: !this.bookingSource.isDragDropReschedule,
                            hide: false,
                        },
                        clear: () => {
                            this.form.instrument = null;
                        },
                        showLoading: true,
                    };
                },
                /*allInstruments: () => {
                    return {
                        name: "allInstruments",
                        title: "Which instrument?",
                        value: () => this.form.instrument,
                        comp: "SoliInstruments",
                        hide: false,
                        props: () => ({
                            buttons: true,
                            ref: "allInstruments",
                            bookingType: this.form.type.name,
                        }),
                        on: {
                            input: (e) => {
                                this.$_select_instrument(e);
                            },
                        },
                        selection: {
                            data: () => this.form.instrument?.name,
                            hide: false,
                        },
                        clear: () => {
                            this.form.instrument = null;
                        },
                        showLoading: true,
                    };
                },*/
                startDate: () => {
                    return {
                        name: "startDate",
                        title: () =>
                            this.$page.props.staffView ? "What day?" : "When?",
                        subText: this.$page.props.staffView
                            ? null
                            : `Lessons can be ${
                                  this.form.type?.assessment
                                      ? "booked"
                                      : "rescheduled"
                              } up to two weeks in the future. ${
                                  this.bookingSource.isGuestSession
                                      ? "Please try and select a time that works for you on a weekly basis."
                                      : ""
                              }`,
                        value: () => this.form.startDate,
                        comp: this.$page.props.staffView
                            ? "SoliDate"
                            : "SoliDateScroll",
                        hide: false,
                        onDemand: true,
                        props: () => ({
                            ref: "startDate",
                            error: this.errors?.starts_at,
                            future: true,
                            reschedule: this.form.type?.reschedule,
                            type: this.$page.props.staffView
                                ? "date"
                                : this.form.type?.name,
                            events: this.form.templateEvent?.registration_event
                                ? null
                                : this.searchAssignments.map((e) =>
                                      this.globalMomentYMD(e.starts_at)
                                  ),
                            select: false,
                            intervals: this.assignmentIntervals,
                            loading: this.apiLoading,
                            selectedTeacher:
                                !!this.form.teacher &&
                                !this.form.somethingNew &&
                                !this.bookingSource.isGuestSession,
                            selectedInstrument: this.form.instrument?.id,
                            selectedLocation: this.form.location,
                            noLimit:
                                this.form.templateEvent?.registration_event,
                        }),
                        scrollTime: !this.$page.props.staffView,
                        on: {
                            input: (date) => {
                                this.$_select_startDate(
                                    date,
                                    !this.$page.props.staffView
                                );
                            },
                            somethingNew: () => {
                                let formData = {
                                    location: this.form.location,
                                    online: this.form.online,
                                    duration: this.form.duration,
                                };

                                this.jumpToStep(
                                    this.stepSequence.find(
                                        (e) => e.name == "somethingNew"
                                    )
                                );
                                this.form.somethingNew = true;

                                this.$_options_clientChangeRescheduleSteps(
                                    this.event,
                                    formData,
                                    {},
                                    1
                                );

                                this.nextStep();
                            },
                            inputTime: (event) => {
                                event.assignment = this.searchAssignments.find(
                                    (e) => e.id == event.assignment_id
                                );

                                this.form.startTime = event.time;
                                this.$_select_startTime(event);

                                this.form.teacher = event.teacher;
                                this.$_select_teacher(event.teacher);
                            },
                            mounted: () => {
                                this.$_apis_getAssignments();
                            },
                        },
                        /*callback: () => {
                            this.$_apis_getAssignments();
                        },*/
                        selection: {
                            data: () => {
                                if (!this.form.startDate) return null;
                                return this.globalMomentDate(
                                    new Date(this.form.startDate)
                                ); /*return [
                                    this.globalMomentDate(
                                        new Date(this.form.startDate)
                                    ),
                                    this.form.startTime,
                                    this.form.teacher?.name,
                                ];*/
                            },
                            hide: !this.$page.props.staffView,
                        },
                        /*backStep: () => {
                        this.$page.props.staffView
                            ? null
                            : (this.form.startDate = null);
                        this.assignmentIntervals = [];
                    },*/
                        clear: () => {
                            this.form.startDate = null;
                            this.form.startTime = null;

                            if (!this.bookingSource.isGuestSession) return;
                            this.form.teacher = null;
                            this.assignmentIntervals = [];
                            //this.teacherAssignments = [];
                            /*if (!this.$page.props.staffView) {
                            this.assignmentIntervals = [];
                            this.form.startTime = null;
                            this.form.room = null;
                            this.assignment = null;
                            this.availability = null;
                        }*/
                        },
                    };
                },
                startTime: () => {
                    return {
                        name: "startTime",
                        title: () => "What time?",
                        value: () => this.form.startTime,
                        comp: "SoliTime",
                        hide: !this.$page.props.staffView,
                        props: () => ({
                            ref: "startTime",
                            error: this.errors?.starts_at,
                            narrow: this.$vuetify.breakpoint.xs,
                            rules: this.rules.start,
                            intervals: this.form.templateEvent
                                ?.registration_event
                                ? null
                                : this.assignmentIntervals
                                      .flatMap((e) => e.intervals)
                                      .flatMap((e) => e.openTimes),
                            loading: this.apiLoading,
                            singleLesson: !this.form.repeating,
                            select: false,
                        }),
                        classes: ["px-5"],
                        on: {
                            input: (startTime) => {
                                if (
                                    this.form.templateEvent?.registration_event
                                ) {
                                    return;
                                }
                                let event = {
                                    assignment:
                                        this.$_data_getAssignmentFromInterval(
                                            startTime
                                        ),
                                };
                                this.form.startTime = startTime;
                                this.$_select_startTime(event);
                            },
                            selectTime: () => {
                                //this.nextStep();
                                //this.$_select_startTime(startTime);
                            },
                        },
                        selection: {
                            data: () => this.form.startTime,
                            hide: false,
                        },
                        continue: this.form.templateEvent?.registration_event,
                        clear: () => {
                            this.form.startTime = null;
                            /*if (!this.$page.props.staffView) {
                            this.form.startDate = null;
                        }
                        this.form.startTime = null;
                        this.form.room = null;
                        this.assignmentIntervals = [];
                        this.assignment = null;
                        this.availability = null;*/
                        },
                        showLoading: true,
                    };
                },
                room: () => {
                    return {
                        name: "room",
                        title: () => "Which room?",
                        value: () => this.form.room,
                        comp: "BookingRooms",
                        hide: false,
                        props: () => ({
                            ref: "room",
                            locationId: this.form.location?.id,
                            assignmentRoomId: this.assignment?.room.id,
                            user_id: this.form.teacher?.id,
                            lessonStart: new Date(this.$_data_lessonStart),
                            lessonEnd: new Date(this.$_data_lessonEnd),
                            inStudioOnly: !this.form.online,
                            onlineOnly: this.availability?.online_only,
                            waitlist:
                                this.form.templateEvent?.registration_event,
                        }),
                        stepDependent: {
                            value: () =>
                                this.$_data_lessonStart &&
                                this.$_data_lessonEnd,
                        },
                        onDemand: true,
                        on: {
                            input: (e) => {
                                this.$_select_room(e);
                            },
                        },
                        selection: {
                            data: () => this.form.room?.title,
                            hide: false,
                        },
                        clear: () => {
                            this.form.room = null;
                        },
                    };
                },
                experience: () => {
                    return {
                        name: "experience",
                        title: () => this.getExperienceTitle(),
                        continue: true,
                        value: () => this.form.experience,
                        comp: "BookingExperience",
                        hide:
                            !this.form.type?.assessment &&
                            !this.form.type?.hold,
                        props: () => ({
                            ref: "experience",
                            rules: this.rules.input,
                            lessonType: this.form.type,
                            autofocus: true,
                        }),
                        classes: ["mb-16"],
                        on: {
                            input: (e) => {
                                this.$_select_experience(e);
                            },
                            valid: (e) => {
                                this.experienceValid = !e;
                            },
                            mounted: (e) => {
                                this.experienceValid = false;
                            },
                        },
                        revisit: true,
                        clear: () => (this.experienceValid = true),
                    };
                },
                /*clientInfo: () => {
                    return {
                        name: "clientInfo",
                        title: "Who is learning?",
                        value: () => this.form.clientInfo,
                        comp: "BookingClientInfo",
                        hide: false,
                        props: () => ({
                            ref: "clientInfo",
                            errors: this.errors,
                        }),

                        on: {
                            valid: (e) => {
                                this.validClientInfo = e;
                            },
                            mounted: (e) => {
                                this.validClientInfo = false;
                            },
                        },
                        selection: {
                            data: () => "TODO",
                            hide: false,
                        },
                        showLoading: true,
                        saveBtn: true,
                        clear: () => {
                            this.form.student = null;
                            this.form.courtesyReschedule = false;
                        },
                    };
                },*/
                clientInfo: () => {
                    return {
                        name: "clientInfo",
                        title: () => "Who is learning?",
                        header: false,
                        hideProgress: false,
                        hideTitle: true,
                        value: () => this.form.clientInfo,
                        comp: "BookingClientInfo",
                        hide: false,
                        props: () => ({
                            ref: "clientInfo",
                            errors: this.errors,
                            clientInfo: this.form.clientInfo,
                        }),
                        on: {
                            valid: (e, info) => {
                                this.validClientInfo = e;
                            },
                            mounted: (e) => {
                                this.validClientInfo = false;
                            },
                        },
                        selection: {
                            data: () => null,
                            hide: false,
                        },
                        continue: true,
                        clear: () => {
                            this.validClientInfo = true;
                        },
                    };
                },
                payment: () => {
                    return {
                        name: "payment",
                        title: () => "Almost there!",
                        header: false,
                        hideProgress: false,
                        hideTitle: true,
                        value: () => this.form.payment,
                        comp: "BookingPayment",
                        hide: false,
                        payment: true,
                        props: () => ({
                            ref: "payment",
                            errors: this.errors,
                            email: this.form.clientInfo?.email,
                            location_id: this.event?.lesson?.room?.location_id,
                            teacherName: this.event?.lesson?.teacher?.name,
                            lessonType: this.event?.lesson?.type,
                        }),
                        on: {
                            paymentLoading: (e) => {
                                this.loading = e;
                            },
                            submit: (data) => {
                                this.form.payment = data.payment;
                                this.form.priceId = data.priceId;
                                this.submit();
                            },
                        },
                        onDemand: true,
                        selection: {
                            data: () => null,
                            hide: false,
                        },
                        clear: () => {},
                    };
                },
                occurrences: () => {
                    return {
                        name: "occurrences",
                        title: () => "How many occurrences?",
                        value: () => this.form.occurrences,
                        comp: "BookingOccurrences",
                        hide: false,
                        props: () => ({
                            ref: "occurrences",
                            recommended: this.form.templateEvent?.occurrences,
                        }),
                        on: {
                            input: (e) => {
                                this.$_select_occurrences(e);
                            },
                            valid: (e) => {
                                this.occurrencesValid = !e;
                            },
                        },
                        selection: {
                            data: () =>
                                this.form.occurrences
                                    ? `${this.form.occurrences} 
                                      ${this.form.templateEvent?.freq_human}`
                                    : null,
                            hide: false,
                        },
                        classes: ["pa-3"],
                        continue: true,
                        revisit: true,
                        clear: () => {
                            this.form.occurrences = null;
                        },
                    };
                },
                capacity: () => {
                    return {
                        name: "capacity",
                        title: () => "How many students can attend?",
                        value: () => this.form.capacity,
                        comp: "BookingCapacity",
                        hide: false,
                        props: () => ({
                            ref: "capacity",
                            recommended: this.form.templateEvent?.capacity ?? 1,
                        }),
                        on: {
                            input: (e) => {
                                this.$_select_capacity(e);
                            },
                            valid: (e) => {
                                this.capacityValid = !e;
                            },
                        },
                        selection: {
                            data: () =>
                                this.form.capacity
                                    ? "Capacity: " + this.form.capacity
                                    : null,
                            hide: false,
                        },
                        classes: ["pa-3"],
                        continue: true,
                        revisit: true,
                        clear: () => {
                            this.form.capacity = null;
                            this.capacityValid = true;
                        },
                    };
                },
                confirm: () => {
                    return {
                        name: "confirm",
                        confirm: true,
                        comp: "BookingConfirm",
                        title: () => `Confirm ${this.form.type?.name}`,
                        hide: false,
                        props: () => ({
                            form: this.form,
                        }),
                        hideProgress: true,
                        hideCancelBtn: true,
                        value: () => null,
                        backStep: () => null,
                        clear: () => {
                            if (this.form.somethingNew) {
                                this.form.teacher = null;
                                this.assignmentIntervals = [];
                            }
                        },
                    };
                },
            },
        };
    },

    methods: {
        /*findInSequence(step) {
            return this.stepSequence.find((e) => e.name == step);
        },*/
        /*getHideLocation() {
            return (
                this.$page.props.auth.user.locations.length == 1 &&
                !this.bookingSource.isCalendar
            );
        },*/
        getExperienceTitle() {
            if (this.form.type?.hold) {
                return "Why are you booking this hold?";
            }

            let guestChild = this.form.clientInfo?.child_first_name;
            let student = this.form.student?.name?.split(" ")[0];
            let subject = null;
            let teacher =
                this.form.teacher?.name?.split(" ")[0] ??
                this.event.lesson?.teacher.name;

            if (this.$page.props.auth.user) {
                if (this.$page.props.auth.user.id == student.id)
                    subject = "your";
                subject = `${student}'s`;
            } else {
                subject = guestChild ? `${guestChild}'s` : "your";
            }

            return ` What is ${subject} experience with ${(
                this.form.instrument?.name ||
                this.event.lesson?.instrument?.name
            ).toLowerCase()} and in music? This will help ${teacher} prepare for this lesson.`;
        },
        getHideAssessmentType() {
            let eventType = this.form.type || this.event.type;
            let hide =
                (!eventType.assessment || this.$_data_teachesPiano == false) ??
                false;
            return hide;
        },
        getHideOnline() {
            if (
                this.form.credit?.group_event?.in_studio_only &&
                !this.form.substitutePass
            ) {
                return true;
            }
            if (!this.availability) return false;
            if (this.form.templateEvent?.in_studio_only) return true;
            return this.availability.online_only && this.$page.props.staffView;
        },
        getHideOccurrences() {
            if (this.form.templateEvent?.occurrences) return false;
            return true;
        },
        getHideBillingUser() {
            if (!this.form.billingUser) return true;
            if (!this.form.type?.assessment) return true;
            if (!this.form.student) return true;
            if (this.form.student?.id == this.form.billingUser?.id) {
                return true;
            }
            //if (this.form.student?.relationships_up.length <= 1) return true;
            //if (!this.form.billingUser) return true;
            return false;
        },
        getBillingUserOptions() {
            if (!this.form.student) return [];
            let includeStudent = this.form.student?.email
                ? this.form.student
                : null;
            return [
                ...[includeStudent],
                ...this.form.student?.relationships.filter((e) => e.email),
            ].filter((e) => e);
        },
        getStudentSubText() {
            if (!this.$page.props.staffView) return;
            if (this.form.type?.assessment) return;
            return `Students with ${
                this.form.type?.reschedule
                    ? "lessons that can be rescheduled"
                    : this.form.duration
                    ? `passes or memberships for a ${this.form.duration} minute ${this.form.type?.name}`
                    : `passes or memberships for a ${this.form.type?.name}.`
            }`;
        },
        getHideSomethingNew() {
            return false;
            if (this.form.credit?.group_event?.can_exchange_passes) {
                return true;
            }
            if (this.bookingSource.isMySchedule) return false;
            return true;
        },
        getHideSubstitutePass() {
            if (this.event?.group_event?.can_exchange_passes) return false;
            if (this.form.credit?.group_event?.can_exchange_passes) {
                return false;
            }
            return true;
        },
        getTotalLessonCredits() {
            if (!this.form?.type.reschedule) return;
            if (this.form.credit?.duration) return this.form.credit.duration;
            if (this.apiCancelledLessons)
                return this.apiCancelledLessons["totalMinutes"];
        },
    },
};
